import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HeaderComponent } from '../../shared/header.component';
import { CdkTableModule } from '@angular/cdk/table';
import { GroupsService } from '../groups.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EditStudentsComponent } from './edit-students.component';
import { StudentDto } from '@oracychampions/api-interfaces';
import { ConfirmComponent } from '../../shared/confirm.modal';
import { Observable } from 'rxjs';
import { CardComponent } from '../../shared/card.component';

@Component({
  selector: 'oc-students',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, CdkTableModule, CardComponent],
  providers: [],
  template: ` <div class="container-fluid page">
    <oc-header headerTitle="Students">
      <button class="btn btn-primary btn-rounded" (click)="addStudent()">Add Student</button>
    </oc-header>

    <div class="oc-students-grid">
      <oc-card
        *ngFor="let student of students$ | async"
        [mainTitle]="student.name"
        icon="tablerUser"
        [actions]="actions(student)"
      ></oc-card>
    </div>
  </div>`,
  styles: `
    .oc-students-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      grid-template-rows: repeat(auto, 1fr);
      gap: 1rem;
      justify-content: start;
    }
  `,
})
export class StudentsComponent {
  private groupsService = inject(GroupsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private modalService = inject(NgbModal);
  private toastr = inject(ToastrService);

  public groupId: string;

  public students$: Observable<StudentDto[]>;

  displayedColumns = ['name', 'createDate', 'actions'];

  constructor() {
    this.groupId = this.route.parent?.snapshot.params['id'];
    this.students$ = this.groupsService.getStudents(this.groupId);
  }

  actions(student: StudentDto): any[] {
    return [
      {
        title: 'Marksheets...',
        action: () => {
          this.router.navigate(['/group', this.groupId, 'students', student.id]);
        },
      },
      {
        title: 'Delete',
        action: () => {
          return this.deleteStudent(student);
        },
      },
    ];
  }

  addStudent() {
    const modalRef = this.modalService.open(EditStudentsComponent, { fullscreen: true });
    modalRef.componentInstance.groupId = this.groupId;
    modalRef.closed.subscribe(() => {
      this.groupsService.reloadStudents();
    });
  }

  deleteStudent(student: StudentDto) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.closed.subscribe((confirmed) => {
      if (confirmed) {
        this.groupsService.deleteStudent(student.id).subscribe(() => {
          this.toastr.success('Student deleted');
          this.groupsService.reloadStudents();
        });
      }
    });
  }
}
